import React from "react";
import "./Menu.css";

export default function Menu() {
  return (
    <div className="Menu">
      <button id="top-menu-border">
        <h3 id="left-aligned">はじめから</h3>
        <h3 className="menu-english-text">NEW STORY</h3>
      </button>
      <button className="inactive">
        <h3 id="left-aligned">つづきから</h3>
        <h3 className="menu-english-text">CONTINUE</h3>
      </button>
      <button className="active">
        <h3 id="left-aligned">世界の天気</h3>
        <h3 className="menu-english-text">WORLD WEATHER</h3>
      </button>
      <button className="inactive">
        <h3 id="left-aligned">オプション</h3>
        <h3 className="menu-english-text">OPTION</h3>
      </button>
      <button className="inactive">
        <h3 id="left-aligned">出口</h3>
        <h3 className="menu-english-text">EXIT</h3>
      </button>
    </div>
  );
}
